import { ChangeEvent, useState } from "react";
import { IOption } from "../SendInappEventParam";

interface EventNameState {
  type: "predefined" | "custom";
  value: string;
}

interface EventParamState {
  type: "predefined" | "custom";
  value: string;
}

export const useInappEventForm = () => {
  const [eventName, setEventName] = useState<EventNameState>({
    type: "predefined",
    value: "",
  });
  const [eventParams, setEventParams] = useState<EventParamState[]>([
    { type: "predefined", value: "" },
  ]);
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const maxParamCount = 5;

  const handleEventNameTypeChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEventName({
      type: e.target.value as "predefined" | "custom",
      value: "",
    });
  };

  const handleEventNameValueChange = (value: string | IOption) => {
    setEventName({
      ...eventName,
      value: typeof value === "object" ? value.value : value,
    });
  };

  const handleAddParameter = () => {
    if (eventParams.length < maxParamCount) {
      setEventParams([...eventParams, { type: "predefined", value: "" }]);
    }
  };

  const handleRemoveParameter = (index: number) => {
    const updated = [...eventParams];
    updated.splice(index, 1);
    setEventParams(updated);
  };

  const handleParamTypeChange = (
    index: number,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const updated = [...eventParams];
    updated[index].type = event.target.value as "predefined" | "custom";
    if (event.target.value === "predefined") updated[index].value = "";
    setEventParams(updated);
  };

  const handleParamValueChange = (index: number, value: string) => {
    const updated = [...eventParams];
    updated[index].value = value;
    setEventParams(updated);
  };

  const handleValueChange = (index: number, value: string | IOption) => {
    const updated = [...eventParams];
    updated[index].value = typeof value === "object" ? value.value : value;
    setEventParams(updated);
  };

  const paramValues = eventParams.map((p) => p.value).filter(Boolean);

  return {
    eventName,
    eventParams,
    hoveredRow,
    setHoveredRow,
    paramValues,
    handleEventNameTypeChange,
    handleEventNameValueChange,
    handleAddParameter,
    handleRemoveParameter,
    handleParamTypeChange,
    handleParamValueChange,
    handleValueChange,
  };
};
